import {
  GetAllProjectBomList
} from '@/api'
export default {
  namespaced: true,
  state: {
    selectedBomId: null,
    bomList: [],
    bomListLoading: false,
    selectedBomVersionId: null,
    bomSearchKeyword: '',
    selectedProductCodeId: null,
    productCodeList: []
  },
  getters: {
    selectedBomId: state => state.selectedBomId,
    bomList: state => state.bomList,
    bomListLoading: state => state.bomListLoading,
    selectedBomVersionId: state => state.selectedBomVersionId,
    bomSearchKeyword: state => state.bomSearchKeyword,
    selectedProductCodeId: state => state.selectedProductCodeId,
    productCodeList: state => state.productCodeList
  },
  mutations: {
    SET_SELECTED_BOM_ID (state, payload) {
      state.selectedBomId = payload.bom_id || null
    },
    SET_BOM_LIST (state, payload) {
      state.bomList = payload
    },
    SET_BOM_LIST_LOADING (state, payload) {
      state.bomListLoading = payload
    },
    SET_SELECTED_BOM_VERSION_ID (state, payload) {
      state.selectedBomVersionId = +payload.bom_version_id || null
    },
    SET_BOM_SEARCH_KEYWORD (state, payload) {
      state.bomSearchKeyword = payload
    },
    SET_SELECTED_PRODUCT_CODE_ID (state, payload) {
      state.selectedProductCodeId = payload || null
    },
    SET_PRODUCT_CODE_LIST (state, payload) {
      state.productCodeList = payload || []
    }
  },
  actions: {
    setBaseData ({ commit }, payload) {
      commit('SET_SELECTED_BOM_ID', payload)
      commit('SET_SELECTED_BOM_VERSION_ID', payload)
    },
    setSelectedBomId ({ commit }, payload) {
      commit('SET_SELECTED_BOM_ID', payload)
    },
    setSelectedBomVersionId ({ commit }, payload) {
      commit('SET_SELECTED_BOM_VERSION_ID', payload)
    },
    getBomList ({ commit, state }, payload = {}) {
      const selectedProductCodeId = Object.prototype.hasOwnProperty.call(payload, 'productCodeId')
        ? payload.productCodeId
        : state.selectedProductCodeId
      if (!selectedProductCodeId) {
        commit('SET_BOM_LIST', [])
        return
      }
      commit('SET_BOM_LIST_LOADING', true)
      GetAllProjectBomList(false, false, selectedProductCodeId).then((res) => {
        commit('SET_BOM_LIST', res.core_bom)
      }).finally(() => {
        commit('SET_BOM_LIST_LOADING', false)
      })
    },
    addBomSearchKeyword ({ commit }, payload) {
      commit('SET_BOM_SEARCH_KEYWORD', payload)
    },
    setSelectedProductCodeId ({ commit }, payload) {
      commit('SET_SELECTED_PRODUCT_CODE_ID', payload)
    },
    setProductCodeList ({ commit }, payload) {
      commit('SET_PRODUCT_CODE_LIST', payload)
    },
    async selectProductCodeAndFetchBoms ({ dispatch }, payload) {
      dispatch('setSelectedProductCodeId', payload)
      await dispatch('getBomList', { productCodeId: payload })
    }
  }
}
